<template>
  <section class="pb-5 px-6">
    <div class="columns is-justify-content-center">
      <div class="column is-5 mb-5">
        <h1 class="is-size-2 has-text-weight-semibold has-text-centered">
          {{ $t('tax.final-taxes-calculator') }}
        </h1>
      </div>
    </div>
    <div class="columns is-justify-content-center">
      <div class="column is-10 mb-5">
        <p class="has-text-centered is-size-5">
          {{ $t('tax.final-taxes-jurisdiction') }}
        </p>
      </div>
    </div>
    <div class="columns is-justify-content-center">
      <div class="column is-10 mb-5">
        <FormMultiSelect
          v-model="computedValue"
          :config="jurisdictionSelectConfig"
          class="p-b-0 is-half"
          :rules="{ required: true }"
          @select="onSelect"
          :data-e2e="TaxCypressAttribute.finalTaxesCalculator.inputs.SELECT_JURISDICTION"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { TaxCypressAttribute } from '@/modules/tax/constants/TaxCypressAttribute';
import FormMultiSelect from '@/modules/core/form/components/FormMultiSelect.vue';
import { FormSelectConfig } from '@/modules/core/form/models/FormSelectConfig';
import { PredefinedJurisdiction } from '@/modules/predefined/enums/PredefinedJurisdiction';
import { FormComputedValueMixin } from '@/modules/core/form/mixins/FormComputedValueMixin';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FinalTaxesJurisdictionSelector',
  mixins: [FormComputedValueMixin],
  components: { FormMultiSelect },
  static: {
    TaxCypressAttribute
  },
  local() {
    return {
      jurisdictionSelectConfig: new FormSelectConfig({
        placeholder: this.$t('contact.state'),
        options: [
          PredefinedJurisdiction.ALBERTA,
          PredefinedJurisdiction.ONTARIO,
          PredefinedJurisdiction.QUEBEC,
          PredefinedJurisdiction.SASKATCHEWAN,
          PredefinedJurisdiction.MANITOBA,
          PredefinedJurisdiction.BRITISH_COLUMBIA,
          PredefinedJurisdiction.NEW_BRUNSWICK,
          PredefinedJurisdiction.NOVA_SCOTIA,
          PredefinedJurisdiction.PRINCE_EDWARD_ISLAND,
          PredefinedJurisdiction.NEWFOUNDLAND_AND_LABRADOR
        ],
        trackBy: 'id',
        label: 'name'
      })
    };
  },
  methods: {
    onSelect(jurisdiction) {
      this.computedValue = jurisdiction.id;
    }
  }
};
</script>
